import React, { useState } from 'react';
import "../../utils/Style/component/modals.scss";
import { Modal, ProgressBar } from "react-bootstrap";
import DisableCashAdvancePopup from './DisableCashAdvancePopup';
import usePayrollAdvanceApi from '../../api/PayrollAdvanceApi';
import { useDispatch, useSelector } from 'react-redux';
import { setIsFromPayrollPage, setIsOpenCashAdvancePopup, setIsOpenDisableCashAdvancePopup, setPayrollPageActiveButton } from '../../features/AdvancePayrollConfirmPopupSlice';
import { useNavigate } from 'react-router-dom';



function CashAdvancePopup() {
    const [step, setStep] = useState(1);


    const { isOpenCashAdvancePopup, isOpenDisableCashAdvancePopup, payrollCount } = useSelector(state => state.advancePayrollConfirm);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const stepProgress = {
        1: 10,
        2: 60,
    };
    const { GetPayrollAdvanceList } = usePayrollAdvanceApi();
    const currentProgress = stepProgress[step];

    const handleNext = async () => {
        if (step < 2) {
            setStep(step + 1);
        } else {
            dispatch(setIsFromPayrollPage(true));
            await GetPayrollAdvanceList(true);
            dispatch(setIsOpenCashAdvancePopup(false));
            dispatch(setIsOpenDisableCashAdvancePopup(false));
            setStep(1);
            navigate("")
            navigate("/payroll/enablecashadvancetable"); 
        }
    };

     
    const handleGoBack = () => {
        dispatch(setIsOpenDisableCashAdvancePopup(false));
        dispatch(setIsOpenCashAdvancePopup(true));
        setStep(2);
    };

    const handleClosePopups = () => { 
        dispatch(setIsOpenCashAdvancePopup(false));
        dispatch(setIsOpenDisableCashAdvancePopup(false));
        setStep(1);
    };

    const handleDoNotEnableButton = () => {
        dispatch(setIsOpenDisableCashAdvancePopup(true));
        dispatch(setIsOpenCashAdvancePopup(false));
    }

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <div className="mobile-confirmation-modal">
                        <div className='header'>
                            <div className="modal-header-image">
                                <div className='header-title'>
                                    <div className='success-title'>
                                        <img src="/Images/check.png" alt="" className='check' />
                                        Payroll Successfully Submitted for Approval
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='text-popup'>
                            You have successfully submitted the payroll for {payrollCount} employees for management approval
                        </div>
                        <button id="closeModalBtn" className='next-btn' onClick={handleNext}>Next</button>
                    </div>
                );
            case 2:
                return (
                    <div className="mobile-confirmation-modal">
                        <div className='header'>
                            <div className="modal-header-image">
                                <div className='header-title'>
                                    <div className='cash-advance-title'>
                                        <img src="/Images/cash-send-money.svg" alt="" className='check' />
                                        Do you want to enable “Cash Advance” for next month?
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='text-popup'>
                            By enabling “Cash Advance”, your employees will be able to request advance payment on their salaries.<br/>
                            You can manually block some employees.
                        </div>
                        <div className='cash-buttons'>
                            <button className='do-not-enable-btn' onClick={handleDoNotEnableButton}>Do not Enable</button>
                            <button id="closeModalBtn" className='btn btn-success' onClick={handleNext}>Enable Cash Advance</button>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <DisableCashAdvancePopup isOpen={isOpenDisableCashAdvancePopup} setIsOpen={() => dispatch(setIsOpenDisableCashAdvancePopup(false))} handleGoBack={handleGoBack} handleClosePopups={handleClosePopups} />
            <Modal centered show={isOpenCashAdvancePopup} >
                <Modal.Body>
                    <ProgressBar variant="custom" now={100} animated={true} style={{ width: '100%', position: 'relative', height: '10px' }}>
                        <div style={{
                            position: 'absolute',
                            left: `${currentProgress - 10}%`,
                            top: '0',
                            height: '100%',
                            width: '50%',
                            borderRadius: '10px',
                            backgroundColor: '#226D96'
                        }} />
                    </ProgressBar>
                    {renderStepContent()}
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default CashAdvancePopup;
